import type { Project, StatusFilter,User } from '../types/projectsTable';

export const CURRENT_USER: User = {
    fullName: 'Иванов Иван Иванович',
    position: 'Профиль',
    organization: 'Аппарат Губернатора ЯНАО',
};

export const STATUS_META: Record<StatusFilter, { label: string; short: string }> = {
    all: { label: 'Все', short: 'Все' },
    new: { label: 'Создан', short: 'Создан' },
    run: { label: 'В процессе', short: 'В работе' },
    done: { label: 'Завершено', short: 'Завершено' },
};

export const PERIOD_OPTIONS = [
    { value: 'all', label: 'Весь период' },
    { value: '7', label: 'За 7 дней' },
    { value: '30', label: 'За 30 дней' },
    { value: '365', label: 'За год' },
] as const;

export const PER_PAGE_OPTIONS = [25, 50, 75, 100] as const;
